// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2K4Mk","loaderOuter":"PageOverlayLoader_loaderOuter__3uiJM"};